import React from "react";

// Soft coloured orbs that gently drift and twinkle — the signature "Aurora White" ambiance.
const ORBS = [
  { w: 640, h: 640, top: "-14%", left: "-8%", c: "#00E5FF", delay: "0s", drift: "26s", twinkle: "8.5s" },
  { w: 560, h: 560, bottom: "-16%", right: "-6%", c: "#7C3AED", delay: "1.4s", drift: "30s", twinkle: "11s" },
  { w: 440, h: 440, top: "34%", left: "48%", c: "#2DD4BF", delay: "3.2s", drift: "22s", twinkle: "9.5s" },
  { w: 380, h: 380, top: "6%", right: "22%", c: "#5B8DEF", delay: "5s", drift: "34s", twinkle: "13s" },
  { w: 320, h: 320, bottom: "4%", left: "20%", c: "#F472B6", delay: "2.4s", drift: "28s", twinkle: "10.5s" },
];

export const AuroraBackground = ({ variant = "default" }) => {
  const orbs = variant === "muted" ? ORBS.slice(0, 4) : ORBS;
  return (
    <div className="aurora-bg" aria-hidden="true">
      {orbs.map((o, i) => (
        <div
          key={i}
          className="orb"
          style={{
            width: o.w, height: o.h,
            top: o.top, left: o.left, right: o.right, bottom: o.bottom,
            background: o.c,
            "--delay": o.delay, "--drift": o.drift, "--twinkle": o.twinkle,
          }}
        />
      ))}
      <div className="absolute inset-0 grid-lines opacity-30" />
    </div>
  );
};
